__turbopack_context__.v({
  "bottom": "style-module-scss-module__k1-Jjq__bottom",
  "brands": "style-module-scss-module__k1-Jjq__brands",
  "brandsIn": "style-module-scss-module__k1-Jjq__brandsIn",
  "brandsLabel": "style-module-scss-module__k1-Jjq__brandsLabel",
  "colHeading": "style-module-scss-module__k1-Jjq__colHeading",
  "colLink": "style-module-scss-module__k1-Jjq__colLink",
  "colList": "style-module-scss-module__k1-Jjq__colList",
  "copyright": "style-module-scss-module__k1-Jjq__copyright",
  "desc": "style-module-scss-module__k1-Jjq__desc",
  "footer": "style-module-scss-module__k1-Jjq__footer",
  "grid": "style-module-scss-module__k1-Jjq__grid",
  "legal": "style-module-scss-module__k1-Jjq__legal",
  "legalLink": "style-module-scss-module__k1-Jjq__legalLink",
  "logo": "style-module-scss-module__k1-Jjq__logo",
  "logoLink": "style-module-scss-module__k1-Jjq__logoLink",
  "social": "style-module-scss-module__k1-Jjq__social",
  "socialLink": "style-module-scss-module__k1-Jjq__socialLink",
});
